import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { RatingService } from '../services/rating.service'
import { environment } from 'src/environments/environment'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { MatDialog } from '@angular/material/dialog'
import { TranslateService } from '@ngx-translate/core'
import { SharedService } from 'src/app/shared/services/shared.service'

@Component({
	selector: 'app-rating-list',
	templateUrl: './rating-list.component.html',
	styleUrls: ['./rating-list.component.scss'],
})
export class RatingListComponent implements OnInit {
	subscription = new Subscription()
	ratings!: any
	imagePath = environment.attachmentPath
	ratingFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
	}
	totalCount = 0
	id: any
	breadCrumbRout: any
	constructor(
		private routeActivate: ActivatedRoute,
		private ratingService: RatingService,
		private dialog: MatDialog,
		public translate: TranslateService,
		private SharedService: SharedService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.routeActivate.params.subscribe(({ id }) => {
			this.id = id
			this.subscription.add(
				this.routeActivate.queryParams.subscribe((res) => {
					this.ratingFilter.paging.pageNumber = res['page'] || 1
					this.ratingFilter.paging.pageSize = res['count'] || 10
					this.SharedService.handleBreadCrumb('branch-rating', false, {
						id: this.id,
						url: 'layout/service-providers/organization-profile/branch-rating',
					})
					this.getRatingList(id)
				})
			)
		})
	}
	getProgressBarStyles(width: number): object {
		return {
			width: `${width}%`,
		}
	}

	getRatingList(branchId: any) {
		this.subscription.add(
			this.ratingService
				.getAllRatings(
					branchId,
					this.ratingFilter.paging.pageNumber,
					this.ratingFilter.paging.pageSize
				)
				.subscribe((res: any) => {
					this.ratings = res.result
					this.totalCount = res?.result?.branchRating?.clientCounts
				})
		)
	}

	updateStatus(id: any) {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '416',
				height: '360',

				data: {
					image: `assets/images/${'view.svg'}`,
					notflex: true,

					message: 'CONFIRMATION_MESSAGE.HIDE_CONFIRMATION',

					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: 'ACTIONS.HIDE',
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.subscription.add(
							this.ratingService.hideReview(id, true).subscribe((res) => {
								this.getRatingList(this.id)
							})
						)
					}
				},
			})
	}
	pageChanged(pageNumber: number, pageCount: number) {
		this.router.navigate(['/layout/ratings/branch-rating/' + this.id], {
			queryParams: {
				page: pageNumber,
				count: pageCount,
			},
		})
	}
}
